// removed by extract-text-webpack-plugin
module.exports = {"Footer":"_18iJJy7SQmae69WyHD6YjK","anchor":"oHp3oxz2NXqQ6-tByR992"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/Footer.stylesheet.css
// module id = 229
// module chunks = 0